import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Col,
  Row,
  Breadcrumb,
  Dropdown,
  Button,
  message,
  Input,
  Space,
  Spin,
} from "antd";
import { useDispatch } from "react-redux";
import Headings from "../../atoms/Headigs";
import { Popup } from "../../atoms/Popup";
import ListCard from "../../molecules/ListCard";
import ExportFeature from "../../molecules/ExportFeature";
import DeleteVPNAccountPopup from "./ManageVPNAccount/Components/DeleteVPNAccountPopUp";
import VPNAccountLogs from "./ManageVPNAccount/Components/VpnLogs";
import { getUserActivity, exportVpnList, getVpnUserDownloadUrl } from "./ducks/services";
import { getResellerDetals } from "./ducks/action";
import { MoreOutlined, SearchOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useKeycloak } from '@react-keycloak/web';
import axios from "../../../configs/axiosIntereptor";


import moment from "moment";
const PAGE_SIZE = parseInt(process.env.NO_OF_USERS_IN_TABLE || '100', 10);
const getColumnSearchProps = (dataIndex) => {
  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => {
      const searchInput = useRef(null);
      return (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              close();
            }}
            style={{
              marginBottom: 8,
              display: "block",
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                confirm();
                close();
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{
                width: 90,
              }}
            >
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close();
              }}
            >
              close
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
  };
};
const items = [
  {
    key: "1",
    label: (
      <Button type="link" className="c-black font-500">
        View
      </Button>
    ),
  },
  {
    key: "2",
    label: (
      <Button type="link" className="c-black font-500">
        Manage
      </Button>
    ),
  },
  {
    key: "3",
    label: (
      <Button type="link" className="c-black font-500">
        Delete
      </Button>
    ),
  },
  {
    key: "4",
    label: (
      <Button type="link" className="c-black font-500">
        Sessions
      </Button>
    ),
  },
];

const deleteVPNAccountPopup = ({
  userDetails,
  popUpVisibility,
  setPopUpVisibility,
}) => {
  const popupContent = {
    closable: false,
    visibility: popUpVisibility,
    class: "popup-modal",
    width: 583,
    content: (
      <DeleteVPNAccountPopup
        accountDetails={userDetails}
        onClose={() => setPopUpVisibility(false)}
      />
    ),
  };
  return { ...popupContent };
};

const vpnAccountLogsPopup = ({
  userDetails,
  logsPopUpVisibility,
  setLogsPopUpVisibility,
}) => {
  const popupContent = {
    closable: true,
    visibility: logsPopUpVisibility,
    class: "black-modal",
    width: 1500,
    onCancel: () => setLogsPopUpVisibility(false),
    content: (
      <VPNAccountLogs
        accountDetails={userDetails}
        onClose={() => setLogsPopUpVisibility(false)}
      />
    ),
  };
  return { ...popupContent };
};

const ActiveUsers = () => {
  const [load, setLoad] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(1);
  const [popUpVisibility, setPopUpVisibility] = useState(false);
  const [logsPopUpVisibility, setLogsPopUpVisibility] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [columnFilters, setColumnFilters] = useState({}); // Store active column filters
  const history = useHistory();
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();

  // Helper function to build query string from column filters
  const buildQueryStringFromFilters = (filters) => {
    const queryParams = [];
    
    Object.keys(filters).forEach(column => {
      // filters[column] is already a string value (not an array) from onTableChange
      const filterValue = filters[column];
      
      if (filterValue && filterValue.trim() !== '') {
        // For date columns, convert to YYYY-MM-DD format
        if (column === 'created_at' || column === 'expires_at') {
          const dateMatch = filterValue.match(/(\d{1,2})\/(\w{3}|\d{1,2})\/(\d{4})/);
          if (dateMatch) {
            try {
              const date = new Date(filterValue);
              if (!isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                queryParams.push(`${column}=${year}-${month}-${day}`);
              } else {
                queryParams.push(`${column}=${encodeURIComponent(filterValue)}`);
              }
            } catch (e) {
              queryParams.push(`${column}=${encodeURIComponent(filterValue)}`);
            }
          } else {
            queryParams.push(`${column}=${encodeURIComponent(filterValue)}`);
          }
        } else {
          queryParams.push(`${column}=${encodeURIComponent(filterValue)}`);
        }
      }
    });
    
    return queryParams.join('&');
  };

  const popupContent = deleteVPNAccountPopup({
    userDetails,
    popUpVisibility,
    setPopUpVisibility,
  });

  const logspopupContent = vpnAccountLogsPopup({
    userDetails,
    logsPopUpVisibility,
    setLogsPopUpVisibility,
  });

  // Add state for downloads popup

  const ListCol = [
    {
      title: "VPN Account Name",
      dataIndex: "username",
      key: "username",
      ...getColumnSearchProps("username"),
    },
    {
      title: "UUID",
      dataIndex: "uuid",
      key: "uuid",
      ...getColumnSearchProps("uuid"),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => moment(date).format("DD/MMM/YYYY"),
      ...getColumnSearchProps("created_at"),
    },
    {
      title: "Expiry Date",
      dataIndex: "expires_at",
      key: "expires_at",
      render: (date) => date ? moment(date).format("DD/MMM/YYYY") : '-',
      ...getColumnSearchProps("expires_at"),
    },
    {
      title: "Account Type",
      dataIndex: "account_type",
      key: "account_type",
      render: (value) => value ? value.charAt(0).toUpperCase() + value.slice(1) : '-',
      ...getColumnSearchProps("account_type"),
    },
    {
      title: "Subscription Status",
      dataIndex: "expire_status",
      key: "subscription_status",
      render: (expire_status, record) => {
        if (record.expires_at && moment(record.expires_at).isBefore(moment(), 'day')) {
          return 'Expired';
        }
        return 'Active';
      },
      ...getColumnSearchProps("expire_status"),
      onFilter: (value, record) => {
        const isExpired = record.expires_at && moment(record.expires_at).isBefore(moment(), 'day');
        if (value.toLowerCase() === 'active') return !isExpired;
        if (value.toLowerCase() === 'expired') return isExpired;
        return (isExpired ? 'expired' : 'active').includes(value.toLowerCase());
      },
    },
    {
      title: "VPN Account Status",
      dataIndex: "status",
      key: "status",
      render: (data) => (data == "1" ? "Enable" : "Disable"),
      ...getColumnSearchProps("status"),
    },
    {
      title: "Subscription Type",
      dataIndex: "subscription_type",
      key: "subscription_type",
      render: (value) => value ? value.charAt(0).toUpperCase() + value.slice(1) : '-',
      ...getColumnSearchProps("subscription_type"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "left",
      render: (text, record) => {
        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "2") {
                  history.push(`/vpn-users/manage/${record?.username}`);
                } else if (key === "1") {
                  history.push(`/vpn-users/detail/${record?.username}`);
                } else if (key === "3") {
                  setUserDetails(record);
                  setPopUpVisibility(true);
                  setLogsPopUpVisibility(false);
                } else if (key === "4") {
                  setUserDetails(record);
                  setLogsPopUpVisibility(true);
                  setPopUpVisibility(false);
                }
              },
            }}
            placement="bottomRight"
            arrow={{ pointAtCenter: true }}
          >
            <MoreOutlined />
          </Dropdown>
        );
      },
    },
  ];

  const onTableChange = (pagination, filters, sorter) => {
    setLoad(true);
    
    // Store column filters in state
    const activeFilters = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].length > 0) {
        activeFilters[key] = filters[key][0];
      }
    });
    setColumnFilters(activeFilters);
    
    // Build query string from column filters
    const filterQueryString = buildQueryStringFromFilters(activeFilters);
    
    let order =
      sorter?.order == "descend"
        ? "DESC"
        : sorter?.order == "ascend"
        ? "ASC"
        : "";
    setPage(pagination.current);
    
    // Call API with query string from column filters
    getUserActivity(
      pagination.current,
      sorter?.field ? sorter?.field : "",
      order,
      PAGE_SIZE,
      filterQueryString // Send query string instead of single search value
    )
      .then((response) => {
        if (response?.data?.header?.code == 200) {
          setRowData(response?.data?.body);
        }
        setLoad(false);
      })
      .catch((error)=>{
        message.error(error?.response?.data?.header?.message || "Something went wrong");
        setLoad(false);
       })
  };

  // onSearch removed - using column filters instead
  // Local loading states for individual export buttons
  const [exportLoading, setExportLoading] = useState(false);

  // Smart Export handler: backend decides direct CSV vs S3 export
 const handleExport = async () => {
  try {
    setExportLoading(true);
    const filterQueryString = buildQueryStringFromFilters(columnFilters);
    const token = keycloak?.token;

    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/billing/export`,
      { exportType: "vpn_users", queryString: filterQueryString },
      { headers: { Authorization: `Bearer ${token}` }, responseType: "blob", timeout: 10 * 60 * 1000 }
    );

    const contentType = res?.headers?.["content-type"] || "";
    const isJson = contentType.includes("application/json");

    if (isJson) {
      const text = await res.data.text();
      const json = JSON.parse(text);
      if (json?.body?.mode === "queued") {
        message.success("Export queued. Please check Files Exported.");
        setExportLoading(false);
        return { queued: true };
      }
      message.error(json?.header?.message || "Unexpected error");
      setExportLoading(false);
      return;
    }

    const contentDisposition = res.headers["content-disposition"];
    const fileName = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/["']/g, "")
      : `vpn_users_${Date.now()}.csv`;
    const blob = new Blob([res.data], { type: "text/csv" });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.setAttribute("download", fileName);
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);

    setExportLoading(false);
  } catch (err) {
    message.error('Failed to export data');
    setExportLoading(false);
  }
};

  // Export All handler removed (backend decides direct vs S3)


  useEffect(() => {
    getUserActivity(1, "", "", PAGE_SIZE, "")
      .then((response) => {
        if (response?.data?.header?.code == 200) {
          setRowData(response?.data?.body);
        }
        setLoad(false);
      })
      .catch((error) => {
        message.error(error?.response?.data?.header?.message || "Something went wrong");
      });
    dispatch(getResellerDetals());
  }, []);

  return (
    <>
      <Card className="design-card">
        <Row gutter={[24, 30]} justify={"space-between"}>
          {/* <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item>Disrupt</Breadcrumb.Item>
              <Breadcrumb.Item>Active Users</Breadcrumb.Item>
            </Breadcrumb>
          </Col> */}
          <Col span={4}>
            <Headings
              title="VPN Users"
              titleSize={2}
              description={`Manage your VPN Users`}
              space={5}
              descClass="mb-0 c-gray"
            />
          </Col>
          <Col span={16} style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
            {/* Export Feature Component */}
            <ExportFeature
              onExport={handleExport}
              getExportList={exportVpnList}
              getDownloadUrl={getVpnUserDownloadUrl}
              rowData={rowData}
              effectiveTotalRecords={Object.keys(columnFilters || {}).length > 0 ? (rowData?.filtered_records || 0) : (rowData?.total_records || rowData?.filtered_records || 0)}
              exportLoading={exportLoading}
              modalTitle="Exported VPN User Files"
              exportType="vpn_users"
            />
            {/* Main search removed - using column filters instead */}
          </Col>
          <Col span={24}>
            <ListCard
              ListCol={ListCol}
              ListData={Array.isArray(rowData?.data) ? rowData.data : []}
              onChange={onTableChange}
              listClass="nospace-card"
              loading={load}
                total={typeof rowData?.total_records === "number" ? rowData.total_records : (rowData?.filtered_records || 0)}
                filteredRecords={typeof rowData?.filtered_records === "number" ? rowData.filtered_records : (rowData?.total_records || 0)}
              noOfRecords={rowData?.no_of_records}
              totaltitle=""
              pagination={{
                total: rowData?.filtered_records ?? rowData?.total_records,
                current: page,
                showSizeChanger: false,
                pageSize: PAGE_SIZE,
              }}
            />
          </Col>
        </Row>
      </Card>
      <Popup {...popupContent} />
      <Popup {...logspopupContent} />
    </>
  );
};

export default ActiveUsers;
